import { createSlice } from "@reduxjs/toolkit";
import { dummyDashboard } from "src/constants/dummyDashboard";

const initialState = {
  dashboardData: dummyDashboard,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setDashboardData: (state, action) => {
      state.dashboardData = action.payload || dummyDashboard;
    },
  },
});

export const { setDashboardData } = dashboardSlice.actions;
export default dashboardSlice.reducer;